import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/Error';
import {
    SnackbarContent, Snackbar, IconButton, withStyles,
} from '@material-ui/core';
import { clearErrorMessage } from '../../../reduxStore/config/ui';

const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    lower: {
        display: 'flex',
        flexWrap: 'nowrap',
        width: '100%',
    },
    content: {
        flexGrow: 1,
        minHeight: '70vh',
        maxWidth: '100%',
    },
    icon: {
        fontSize: 20,
    },
    iconVariant: {
        opacity: 0.9,
        marginRight: theme.spacing(1),
    },
    message: {
        display: 'flex',
        alignItems: 'center',
    },
    error: {
        backgroundColor: theme.palette.error.dark,
    },
});

const ErrorMessages = ({ classes }) => {
    const dispatch = useDispatch();

    const handleMessageClose = message => () => dispatch(clearErrorMessage(message));

    const errorMessages = useSelector(state => state.ui.errorMessages);

    return (
        <div>
            {errorMessages.map(message => (
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open
                    key={message.id}
                    autoHideDuration={6000}
                    onClose={handleMessageClose(message)}
                >
                    <SnackbarContent
                        className={classes.error}
                        aria-describedby="client-snackbar"
                        message={(
                            <span id="client-snackbar" className={classes.message}>
                                <ErrorIcon className={classes.iconVariant} />
                                {message.text}
                            </span>
                        )}
                        action={[
                            <IconButton
                                key="close"
                                aria-label="Close"
                                color="inherit"
                                className={classes.close}
                                onClick={handleMessageClose(message)}
                            >
                                <CloseIcon className={classes.icon} />
                            </IconButton>,
                        ]}
                    />

                </Snackbar>
            ))}
        </div>
    );
};

ErrorMessages.propTypes = {
    classes: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withStyles(styles)(ErrorMessages);
